import React, {FC, useState, useEffect} from 'react';
import {navigate} from 'gatsby';
import {IPricingCard} from '../../types';
import Flag from '../pricingFlag';
import PricingItem from '../pricingItem';
import Payment from '../payment';
import CustomModal from '../../customModal';
import {Modal} from '../../modal';
import Button from '../../button';
import EmailVerification from '../../emailVerification';
import {GET_HEXOMATIC_USER} from '../../../graphql/queries';
import {useQuery} from '@apollo/react-hooks';
import {trialBadge} from '../../../images';
import './styles.scss';

const PricingCard: FC<IPricingCard> = ({
  trigger,
  name,
  price,
  flag,
  lineThrough,
  pricingList,
  user,
  disabled,
  packeges,
  verified,
  id,
  interval,
  refetch,
  isEnterprise,
  handleEnterpriseClick,
  promo,
  real_price,
  discountAnnual,
  paypal_id,
  ltdPrice,
  currentPlan,
  currentPlanInterval,
  pendingPayment,
  showLtd,
  goldSpecial,
  goldSpecialPrice,
  selected,
  specialLtd,
  annualPromo97097,
}) => {
  //state
  const [selectedValue, setSelectedValue] = useState(
    selected
      ? selected
      : {
          label: '10000',
          value: 1,
        },
  );
  const [showModal, setShowModal] = useState(false);
  const [packageInfo, setPackageInfo] = useState(null);
  const [verifyModal, setVerifyModal] = useState(false);
  const [canUseTrial, setCanUseTrial] = useState(true);
  const [trialPlans, setTrialPlans] = useState<string[]>(['SILVER']);
  const [isTrialSelected, setIsTrialSelected] = useState(false);

  //useEffects
  // useEffect(() => {
  //   verified &&
  //     localStorage.getItem('packageInfo') &&
  //     //@ts-ignore
  //     setPackageInfo(JSON.parse(localStorage.getItem('packageInfo')));
  // }, [verified]);

  // useEffect(() => {
  //   if (packageInfo) {
  //     //@ts-ignore
  //     if (packageInfo.name === 'Gold') {
  //       //@ts-ignore
  //       setSelectedValue(packageInfo.selectedValue);
  //     }
  //     //@ts-ignore
  //     if (!disabled && packageInfo.name === name) {
  //       setShowModal(true);
  //       return;
  //     }
  //     if (
  //       name === 'Gold' &&
  //       //@ts-ignore
  //       packageInfo.name === 'Silver' &&
  //       user.pricing_package === 'GOLD'
  //     ) {
  //       !showModal && setShowModal(true);
  //     }
  //   }
  // }, [packageInfo]);

  const {data: hexomaticUser} = useQuery(GET_HEXOMATIC_USER, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (
      hexomaticUser &&
      hexomaticUser.HexomaticUser &&
      hexomaticUser.HexomaticUser.getByLegacyId &&
      typeof hexomaticUser.HexomaticUser.getByLegacyId.can_use_trial === 'boolean'
    ) {
      setCanUseTrial(hexomaticUser.HexomaticUser.getByLegacyId.can_use_trial);
      hexomaticUser.HexomaticUser.getByLegacyId.trial_packages &&
        setTrialPlans(hexomaticUser.HexomaticUser.getByLegacyId.trial_packages);
    }
  }, [hexomaticUser]);

  //

  const handelClick = (trial?: boolean) => {
    if (annualPromo97097 && !id) return;
    const ltdPriceAjusted = currentPlan === 'SILVER' && name === 'Gold' && currentPlanInterval === 'LTD' ? (specialLtd ? 99 : 199) : 0;
    setIsTrialSelected(!!trial);
    localStorage.setItem(
      'checkout-data',
      JSON.stringify({
        id,
        paypal_id,
        name,
        selectedValue,
        price: goldSpecialPrice ? goldSpecialPrice : showLtd && ltdPrice ? ltdPrice : price,
        ltdPriceAjusted: ltdPriceAjusted,
        isTrial: !!trial,
        interval,
        ltd: showLtd,
        ...(annualPromo97097 ? {promo97097: true} : {}),
      }),
    );
    if (user && !user.id) {
      navigate('/registration');
      return;
    }
    // if (user && user.id && !verified) {
    //   setVerifyModal(true);
    //   return;
    // }
    name !== 'Free' && !disabled && navigate('/pricing/checkout');
  };

  const ltdPriceAjusted = currentPlan === 'SILVER' && name === 'Gold' && currentPlanInterval === 'LTD' ? (specialLtd ? 99 : 199) : 0;

  const content = (
    <div className="pricing-card position-relative m-auto">
      {flag && <Flag color={flag.color} />}
      {canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly' && (
        <div className={`position-absolute trial-flag`}>{trialBadge} </div>
      )}
      <div className="pricing-card-header">
        <div className="name">{name}</div>
        {/*promo && interval === 'annual' && (
          <p className={`line-through w-100 mb-2 ${real_price ? '' : 'invisible'} my-0 f_size_22 text-center`}>
            <span>$ </span>
            {real_price}
            <span>/mo</span>
          </p>
        )*/}

        {isEnterprise ? (
          <div className="enterprice-txt text-center">Get a plan tailored to your unique business needs.</div>
        ) : (
          <>
            {promo && interval === 'annual' && (
              <p
                className={`line-through discount-price  ${
                  real_price || name !== 'Free' ? '' : 'invisible'
                } my-0 mx-auto f_size_22 text-center`}
              >
                <span>$ </span>
                {real_price}
                <span>/mo</span>
              </p>
            )}
            <div className="d-flex">
              <div
                className={`price ${lineThrough || ltdPrice ? 'line-through w-100' : ''} ${
                  goldSpecialPrice ? 'line-through sm' : ''
                }`}
              >
                <sup>$</sup>
                {interval === 'annual'
                  ? String((price * selectedValue.value) / (!(lineThrough || ltdPrice || goldSpecialPrice) ? 12 : 10)).length > 4
                    ? ((price * selectedValue.value) / (!(lineThrough || ltdPrice || goldSpecialPrice) ? 12 : 10)).toFixed(2)
                    : (price * selectedValue.value) / (!(lineThrough || ltdPrice || goldSpecialPrice) ? 12 : 10)
                  : price * selectedValue.value}
               {goldSpecialPrice ? '' : <sub>/mo</sub>}
              </div>
              {goldSpecialPrice ? (
                <div className={`price`}>
                  <sup>$</sup>
                  {interval === 'annual'
                  ? String((goldSpecialPrice * selectedValue.value) / (!(lineThrough || ltdPrice) ? 12 : 10)).length > 4
                    ? Math.round((goldSpecialPrice * selectedValue.value) / (!(lineThrough || ltdPrice) ? 12 : 10))
                    : (goldSpecialPrice * selectedValue.value) / (!(lineThrough || ltdPrice) ? 12 : 10)
                  : goldSpecialPrice * selectedValue.value}
                  <sub>/mo</sub>
                </div>
              ) : null}
            </div>
          </>
        )}
        {isEnterprise ? (
          <div>
            <button
              className={`enterprise-contact btn get-package ${promo && interval === 'annual' ? 'mt-2 pt-3' : ''}`}
              onClick={handleEnterpriseClick}
            >
              Contact us
            </button>
          </div>
        ) : (
          <div
            className={`${
              user && user.id && (name === 'Free' || (name === 'Bronze' && interval === 'ltd'))
                ? 'invisible'
                : 'visible'
            }`}
          >
            <button
              className={`btn get-package ${
                canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly' ? 'trial-btn' : ''
              }`}
              onClick={() =>
                handelClick(!!(canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly'))
              }
              disabled={pendingPayment}
              title={pendingPayment ? 'You have pending payment' : ''}
            >
              {canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly'
                ? 'Try for free'
                : ltdPrice
                ? 'Buy now'
                : 'Subscribe'}
            </button>
          </div>
        )}
        {canUseTrial && interval === 'monthly' && trialPlans?.length ? (
          <div style={{visibility: trialPlans.includes(name.toUpperCase()) ? 'visible' : 'hidden'}}>
            or{' '}
            <span onClick={() => handelClick(false)} className="clickable-text ml-2">
              subscribe
            </span>
          </div>
        ) : (
          ''
        )}
        {!isEnterprise && (
          <div className="purchase">
            {(ltdPrice || goldSpecialPrice) && (
              <span className="mr-1 small-line-through-container">
                <span className="small-line-through">
                  $
                  {name === 'Gold'
                    ? false
                      ? selectedValue.value * ltdPrice - ltdPriceAjusted
                      : selectedValue.value * (goldSpecialPrice ? Math.round(price / 10 * 12) : price)
                    : goldSpecialPrice ? Math.round(price / 10 * 12) : price}
                </span>
              </span>
            )}
            <span style={{fontWeight: goldSpecialPrice ? 700 : 500}} className='mr-1'>
              $
              {name === 'Gold' || name === 'Silver' || name === 'Bronze'
                ? goldSpecialPrice
                  ? goldSpecialPrice * (name === 'Gold' ? selectedValue.value : 1)
                  : ltdPrice
                  ? selectedValue.value * ltdPrice - ltdPriceAjusted
                  : selectedValue.value * price
                : price}
            </span>
            {canUseTrial && trialPlans.includes(name.toUpperCase()) && interval === 'monthly'
              ? 'billed after 7-day free trial'
              : goldSpecialPrice ? 'billed annually' : 'billed upon purchase'}
          </div>
          // <div className="purchase">${name === 'Gold' ? selectedValue.value * price : price} billed upon purchase</div>
        )}
      </div>
      <div className="pricing-card-body">
        {pricingList.map((item: any) => (
          <PricingItem
            text={item.text}
            ltdPrice={ltdPrice || goldSpecialPrice}
            ltdPriceAjusted={ltdPriceAjusted}
            number={item.number}
            isBold={item.isBold}
            isChecked={item.isChecked}
            unlimited={item.unlimited}
            select={item.select}
            selectedValue={selectedValue}
            onChange={(val: any) => setSelectedValue(val)}
            disableSelect={specialLtd && currentPlan === 'SILVER'}
          />
        ))}
      </div>
    </div>
  );
  return (
    <>
      <div
        className={`pricing-card-container ${
          ltdPrice && name === 'Silver' ? 'top_left' : name === 'Silver' ? 'top_left' : isEnterprise ? 'bottom_right' : ''
        } ${name.toLocaleLowerCase()} ${ltdPrice ? 'pricing-card-trigger' : ''} ${
          disabled ? 'pricing-card-disabled' : ''
        }`}
      >
        {ltdPrice && (
          <div className="pricing-trigger">
            <div className="pricing-trigger-wrapper">
              {' '}
              LIFETIME DEAL ${(name === 'Gold' ? ltdPrice * selectedValue.value : ltdPrice) - ltdPriceAjusted}
            </div>
            <div id="triangle-down"></div>
          </div>
        )}

        <div className="trigger-container">
          <>
            {!!trigger && (
              <>
                <div className="pricing-trigger-wrapper">
                  {' '}
                  LIFETIME DEAL ${name === 'Gold' ? trigger * selectedValue.value : trigger}{' '}
                </div>
                <div id="triangle-down"></div>
              </>
            )}
            {content}
          </>
        </div>
      </div>
      {showModal && (
        <CustomModal ShowPopup={showModal} noCloseIcon noNavigate className="payment-modal">
          <Payment
            selectedValue={selectedValue}
            name={isTrialSelected ? name + ' (7-day free trial)' : name}
            price={price}
            packeges={packeges}
            ltdPrice={ltdPrice || goldSpecialPrice}
            ltdPriceGold={interval === 'annual' && showLtd ? (specialLtd && currentPlan === 'SILVER' ? 198 : specialLtd ? 99 : 399) : 0}
            ltdPriceSilver={interval === 'annual' && showLtd ? (specialLtd ? 99 : 199) : 0}
            ltdPriceAdjusted={ltdPriceAjusted}
            user={user}
            setShowPopup={setShowModal}
            id={id}
            refetch={refetch}
            interval={interval}
            paypal_id={paypal_id}
          />
        </CustomModal>
      )}
      {/* {verifyModal && (
        <Modal
          isOpen={verifyModal}
          modalToggle={() => {}}
          modalFooter={
            <Button
              className="w-100"
              onClick={() => {
                setVerifyModal(false);
              }}
            >
              {' '}
              Close{' '}
            </Button>
          }
        >
          <EmailVerification />
        </Modal>
      )} */}
    </>
  );
};

export default PricingCard;
